export const productsData = [
  // Premium Flowers
  {
    id: 1,
    name: "OG Kush",
    category: "flower",
    price: 45,
    thc: "22%",
    description: "Classic strain with earthy pine aroma and powerful relaxation effects.",
    effects: ["Relaxed", "Happy", "Euphoric"],
    imageUrl: "https://fchtwxunzmkzbnibqbwl.supabase.co/storage/v1/object/public/kushie01/videos/Dspsbls%20NeoGreen%20Video.mp4", // Replace with actual PNG
    inStock: true
  },
  {
    id: 2,
    name: "Blue Dream",
    category: "flower",
    price: 50,
    thc: "24%",
    description: "Balanced hybrid with sweet berry aroma and gentle cerebral invigoration.",
    effects: ["Creative", "Uplifted", "Focused"],
    imageUrl: "https://images.unsplash.com/photo-1517849845537-4d257902454a?w=400&h=500&fit=crop",
    inStock: true
  },
  {
    id: 3,
    name: "Gorilla Glue",
    category: "flower",
    price: 55,
    thc: "28%",
    description: "Heavy-handed euphoria and relaxation, leaving you glued to the couch.",
    effects: ["Relaxed", "Sleepy", "Happy"],
    imageUrl: "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=400&h=500&fit=crop",
    inStock: true
  },
  {
    id: 4,
    name: "Sour Diesel",
    category: "flower",
    price: 48,
    thc: "26%",
    description: "Energizing, dreamy cerebral effects with a pungent diesel aroma.",
    effects: ["Energetic", "Creative", "Happy"],
    imageUrl: "https://images.unsplash.com/photo-1536819114556-1e10f967fb61?w=400&h=500&fit=crop",
    inStock: true
  },

  // Edibles
  {
    id: 5,
    name: "Gummy Bears",
    category: "edible",
    price: 25,
    thc: "10mg each",
    description: "Assorted fruit flavors, perfect for micro-dosing throughout the day.",
    effects: ["Relaxed", "Happy", "Calm"],
    imageUrl: "https://images.unsplash.com/photo-1499195333224-3ce974eecb47?w=400&h=500&fit=crop",
    inStock: true
  },
  {
    id: 6,
    name: "Chocolate Bar",
    category: "edible",
    price: 30,
    thc: "100mg",
    description: "Rich dark chocolate infused with premium cannabis extract.",
    effects: ["Euphoric", "Relaxed", "Sleepy"],
    imageUrl: "https://images.unsplash.com/photo-1481391319762-47dff72954d9?w=400&h=500&fit=crop",
    inStock: true
  },
  {
    id: 7,
    name: "Cookie Bites",
    category: "edible",
    price: 28,
    thc: "5mg each",
    description: "Delicious chocolate chip cookie bites, perfect for beginners.",
    effects: ["Happy", "Relaxed", "Uplifted"],
    imageUrl: "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=400&h=500&fit=crop",
    inStock: true
  },

  // Concentrates
  {
    id: 8,
    name: "Live Resin",
    category: "concentrate",
    price: 65,
    thc: "85%",
    description: "Premium live resin extracted from fresh frozen plants.",
    effects: ["Intense", "Euphoric", "Creative"],
    imageUrl: "https://images.unsplash.com/photo-1598662957563-ee4965d4d72c?w=400&h=500&fit=crop",
    inStock: true
  },
  {
    id: 9,
    name: "Shatter",
    category: "concentrate",
    price: 60,
    thc: "82%",
    description: "Glass-like concentrate with potent effects and clean flavor.",
    effects: ["Powerful", "Focused", "Energetic"],
    imageUrl: "https://images.unsplash.com/photo-1602080858428-57174f9431cf?w=400&h=500&fit=crop",
    inStock: true
  },
  {
    id: 10,
    name: "Wax",
    category: "concentrate",
    price: 55,
    thc: "78%",
    description: "Soft, opaque concentrate perfect for dabbing.",
    effects: ["Relaxed", "Happy", "Euphoric"],
    imageUrl: "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=400&h=500&fit=crop",
    inStock: true
  }
]